module.exports = __webpack_public_path__ + "static/img/audio-joystick.39257b11.png";